import React from 'react';
import Rive from '@rive-app/react-canvas';
const CopiriLoader = ({ width, height }) => (
	<div className='showRiveLoader'>
		{width && height ? (
			<Rive src='/rive_loader.riv' style={{ width: width, height: height }} />
		) : (
			<Rive src='/rive_loader.riv' style={{ width: '125px', height: '125px' }} />
		)}
	</div>
);

export default CopiriLoader;
